import React, { MouseEvent } from "react";
import { IfComp } from "@dvrt/react-tools";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "@mui/material";
import { FormattedMessage } from "react-intl";

export const Item = ({
    href,
    onClick,
    icon,
    label,
}: {
    href: string;
    onClick?: () => void;
    icon?: IconDefinition;
    label: string;
}) => {
    const clickHandler = onClick
        ? (event: MouseEvent) => {
              event.preventDefault();
              event.stopPropagation();
              onClick();
          }
        : null;
    return (
        <MenuItem onClick={clickHandler} component="a" href={href}>
            <IfComp condition={icon !== undefined}>
                <FontAwesomeIcon icon={icon} style={{ paddingRight: "5px" }} />
            </IfComp>
            <FormattedMessage id={label} />
        </MenuItem>
    );
};
